module.exports = __webpack_public_path__ + "static/media/top.761a1e09.png";